import { useMutation } from '@tanstack/react-query'
import { FileAction, useFilesContext } from '../files-context'
import { request } from 'lib/api/fetch-api'
import { AssetableType } from 'lib/api/ticket-files/ticket-files'
import { toast } from 'lib/components/toast/toast'
import Modal from 'lib/components/modals/modal'
import IconButton from 'lib/components/buttons/icon-button'
import { ArrowLeftIcon } from 'lucide-react'
import { FileExportModalMode } from './file-modal'
import CurrentAsset from './current-asset-screen'
import AddDeliverablesTable from 'components/elements/projects/add-deliverables-table'
import { Ticket } from 'interfaces/ticket'
import AddToToastActions from './add-to-toast-actions'

const AddToRequestScreen = () => {
  const { setMode, files, onFinish } = useFilesContext()

  const { mutate: updateTicketFile } = useMutation({
    mutationFn: (ticketIds: number[]) =>
      request({
        endpoint: 'duplicateTicketFile',
        query: {
          ticket_file_id: files[0].id,
        },
        body: {
          data: ticketIds.map((ticketId) => ({
            assetable_type: AssetableType.Ticket,
            assetable_id: ticketId,
          })),
        },
      }),
    onSuccess: ({ data }) => {
      setMode(null)
      for (const ticket of data as Ticket[]) {
        toast.success(`Asset(s) added to request "${ticket.subject || 'Untitled'}"`, {
          action: <AddToToastActions url={`${window.location.origin}/tickets/${ticket.id}`} type="request" />,
        })
      }
      onFinish?.({ action: FileAction.UPDATE, ticketFiles: files })
    },
    onError: () => {
      toast.error('Asset(s) could not be added to request(s)')
    },
  })

  const handleAddToRequest = (ticketIds: number[]) => {
    updateTicketFile(ticketIds)
  }

  return (
    <>
      <Modal.Header className="tw-font-bold">
        <IconButton
          className="tw-mb-2"
          size="xs"
          color="transparent"
          onClick={() => setMode(FileExportModalMode.ADD_TO)}
        >
          <ArrowLeftIcon className="tw-text-neutral-700" />
        </IconButton>
        Add to request
        <div className="tw-text-sm tw-font-normal">Select which request(s) you&apos;d like to add asset(s) to</div>
      </Modal.Header>
      <Modal.Body
        className="tw-mt-4 tw-flex tw-max-h-[700px] tw-flex-col tw-gap-2 tw-text-neutral-800"
        setOpen={() => setMode(null)}
        closeButton
      >
        <CurrentAsset />
        <AddDeliverablesTable
          onFinished={() => {}}
          handleAddDeliverables={handleAddToRequest}
          buttonText="Add to request(s)"
          selectedText="selected"
          showCreateButton={false}
        />
      </Modal.Body>
    </>
  )
}

export default AddToRequestScreen
